import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { EncodeHttpParamsInterceptor } from '../services/http/encode-http-params.interceptor';

export const paramEncodingInterceptorProvider: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: EncodeHttpParamsInterceptor,
    multi: true
};
